"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const index_1 = require("../../index");
const BasePopup_1 = __importDefault(require("./BasePopup"));
const Popup = ({ show, close, size = 'large', body, title, buttons }) => {
    return (React.createElement(BasePopup_1.default, { show: show, close: close, size: size },
        React.createElement("h1", { className: "popup-title" }, title),
        React.createElement(index_1.Spacer, { size: "xs" }),
        typeof body === 'string' ?
            React.createElement("p", null, body) : body,
        buttons && React.createElement(index_1.Spacer, { size: "sm" }),
        React.createElement("div", { className: "popup-buttons" }, buttons)));
};
exports.default = Popup;
//# sourceMappingURL=Popup.js.map